import React, { Component } from 'react';
import { StyleSheet, css } from 'aphrodite';
import async from 'async';
import moment from 'moment';
import { SectionProgress } from '../components/quizzing/SectionProgress';
import { AppConfig } from '../AppConfig';
import { CommonStyles } from '../styles/Styles';
import { StepperButtonComponent } from '../components/quizzing/StepperButtonComponent';
import { SubmitConfirmation } from '../components/SubmitConfirmation';
import { ApiHelper } from '../common/helpers/ApiHelper';
import { UiHelper } from '../common/helpers/UiHelper';
import { Helper } from '../common/helpers/Helper'
import { Controller } from '../common/Controller';
import { AppTheme, AppStyles } from '../styles/AppTheme';
import { FormFieldComponent } from '../components/quizzing/FormFieldComponent';
import { MsgDialog } from '../components/MsgDialog';
import { AppHelper } from '../helpers/AppHelper';

export class SurveySection extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fetchState: ApiHelper.State.LOADING,
      inProcess: false,
      errMsg: null,
      tagQues: null,
      tagByQuestionId: {},
      confirmationDialog: false,
      showMsgDialog: false,
      submitAnswerPopup: localStorage.getItem('submitAnswerPopup') === 'YES' ? true : false,
      visitLaterPopup: localStorage.getItem('visitLaterPopup') === 'YES' ? true : false,
      retake: false
    };
    this.slug = this.props.match.params.id ? this.props.match.params.id : null
    this.responseByQuestionId = {}
    this.surveyData = (this.props.location.state && this.props.location.state.item) ? props.location.state.item : null
  }

  componentDidMount() {
    /*if (this.surveyData) {
      this.init([this.surveyData])
    } else {
      this.fetchItems();
    }*/
    this.fetchItems(); //TODO: always fethcing since there is a cache issue
  }

  fetchItems() {
    ApiHelper.call(
      { method: 'GET', endPoint: ApiHelper.makeUrlPath(['/miscs/quiz-progress'], { quizId: AppConfig.quizId }) },
      function (err, result) {
        if (err) {
          this.setState({
            fetchState: ApiHelper.State.ERROR,
            errMsg: Helper.getErrorMsg(err)
          })
          return
        }
        this.init(result.sections) 

      }.bind(this))
  }

  init = (sections) => {
    const activeStepDetails = this.findActiveSurveySection(sections)
    this.setState({
      surveySection: activeStepDetails.surveySection,
      activeStep: activeStepDetails.activeStep
    }, () => this.fetchQuesItems(activeStepDetails.surveySection))
  }


  findActiveSurveySection(items) {
    for (const item of items) {
      if (item.id === this.slug) {
        let i
        const subsections = item.subsections
        const sortedSubsections = subsections.sort((a, b) => Number(a.order) - Number(b.order))
        item.subsections = sortedSubsections
        for (i = 0; i < item.subsections.length; i++) {
          if (item.subsections[i].complete !== true) {
            break;
          }
        }
        return ({
          surveySection: item,
          activeStep: i < item.subsections.length ? i : i - 1
        })
      }
    }
  }

  fetchQuesItems(item) {
    const thisObj = this;
    const fcns = [];
    for (const subsection of item.subsections) {
      fcns.push(function (callback) {
        ApiHelper.call(
          {
            method: 'GET', endPoint: ApiHelper.makeUrlPath(['/miscs/questions'], { groupId: subsection.id })
          }, callback)
      }.bind(this))
    }

    async.parallel(fcns, function (err, results) {
      if (err) {
        thisObj.setState({
          fetchState: ApiHelper.State.ERROR,
          errMsg: Helper.getErrorMsg(err)
        })
        return
      }
      thisObj.setTableNum(results)
      thisObj.setTagQuestions(results)
      thisObj.setState({
        subSectionQuestions: results,
        fetchState: ApiHelper.State.READY
      })
    })
  }

  setTableNum = (subSectionQuestions) => {
    let tableNumDict = {}
    subSectionQuestions.map((sub, index) => {
      sub.items.sort(function (a, b) { return (Number(a.order) - Number(b.order)) })
      sub.itemsFromBknd =  sub.items
      const subItems = []
      for(const ques of sub.items) {
        if (ques.tableNum && (ques.type === 'OPTIONS-MUL' || ques.type === 'OPTIONS-SINGLE')) {
          if (tableNumDict[ques.tableNum]) {
            tableNumDict[ques.tableNum].push(ques)
          } else {
            tableNumDict[ques.tableNum] = [ques]
          }
        } else {
          subItems.push(ques)
        }
      }

      const tableNumFormFields = []
      Object.keys(tableNumDict).map(key => {
        tableNumFormFields.push({
          order: tableNumDict[key][0].order,
          tag: tableNumDict[key][0].tag,
          type: this.shouldAcceptOptions(tableNumDict[key][0]) ? 'TABULAR_SELECT' : 'TABULAR',
          images: this.shouldAcceptOptions(tableNumDict[key][0]) ?  [tableNumDict[key][0].image2, tableNumDict[key][0].image3 ] : [],
          image: this.shouldAcceptOptions(tableNumDict[key][0]) ?  tableNumDict[key][0].image : null,
          tableNum: key,
          options: this.shouldAcceptOptions(tableNumDict[key][0])  ? [] : tableNumDict[key][0].options,
          subQuestions: tableNumDict[key]
        })
      })

      sub.items = subItems.concat(tableNumFormFields)
      sub.items.sort(function (a, b) { return (Number(a.order) - Number(b.order)) })

      tableNumDict = {}
    })
  }

  shouldAcceptOptions = (ques) => {
    if(!ques || !ques.options) return false
    let acceptOptionsMode = true
    for(const key of  Object.keys(ques.options)) {
      if (!ques.options[key].acceptOptions) {
        acceptOptionsMode = false
        break
      }
    }
    return acceptOptionsMode
  }

  setTagQuestions = (subSectionQuestions) => {
    const tagByQuestionId = {}
    subSectionQuestions.map((sub, index) => {
      sub.items.map(ques => {
        if (ques.options) {
          Object.keys(ques.options).map(option => {
            if (ques.options[option].tag) {
              sub.items.sort(function (a, b) { return (Number(a.order) - Number(b.order)) })
                .map(tagQues => {
                  if (tagQues.tag === ques.options[option].tag) {
                    if (tagByQuestionId[ques.id]) {
                      tagByQuestionId[ques.id].push({
                        quesId: ques.id,
                        ansId: option,
                        tagId: tagQues.tag,
                        tagQuesId: tagQues.id,
                        tagQues: tagQues,
                        show: false
                      })
                    } else {
                      tagByQuestionId[ques.id] = [{
                        quesId: ques.id,
                        ansId: option,
                        tagId: tagQues.tag,
                        tagQuesId: tagQues.id,
                        tagQues: tagQues,
                        show: false
                      }]
                    }
                  }
                })
            }
          })
        }
      })
    })
    this.setState({
      tagByQuestionId: tagByQuestionId
    })
  }

  handleStep = (step, id) => () => {
    this.setState({
      errMsg: null,
      activeStep: step,
      retake: false
    });
    this.responseByQuestionId = {}
  };

  handleState = (id, value) => {
    this.responseByQuestionId[id] = value
    this.getQuesTag(id)
    //console.log('this.responseByQuestionId', this.responseByQuestionId)
  }

  handleVisitLater = (e) => {
    this.setState({ visitLaterPopup: e.target.checked });
  }

  confirmationDialogClose = () => {
    this.setState({ confirmationDialog: false });
  }

  handleCheckbox = (e) => {
    this.setState({ submitAnswerPopup: e.target.checked });
  }

  onSubmit = () => {
    if (this.state.submitAnswerPopup) {
      localStorage.setItem('submitAnswerPopup', 'YES');
    } else {
      localStorage.setItem('submitAnswerPopup', 'NO');
    }

    this.setState({
      confirmationDialog: false
    })
    this.submitAnswers()
  }

  onDone = () => {
    if (this.state.submitAnswerPopup) {
      this.submitAnswers()
    } else {
      this.setState({
        confirmationDialog: true
      })
    }
  }

  onReTake = () => {
    this.setState({
      retake: true
    })
  }

  submitAnswers = () => {
    this.setState({
      inProcess: true,
      errMsg: null
    })
    const jsonBody = {}

    const activeSubsection = this.state.subSectionQuestions[this.state.activeStep]
    for (const q of activeSubsection.itemsFromBknd) {
      const qres = {
        groupId: q.groupId,
        quizId: AppConfig.quizId,
        action: 'SKIP',
      }

      if (!this.responseByQuestionId[q.id] && !this.responseByQuestionId[AppHelper.getOtherValuePrefix() + q.id]) {
        jsonBody[q.id] = qres
        continue
      }

      qres.action = 'SUBMIT'
      qres.answer = {}

      if (this.responseByQuestionId[q.id]) {
        if (q.type === 'YESNO') {
          qres.answer = { id: this.responseByQuestionId[q.id] }
        } else if (q.type === 'OPTIONS-SINGLE') {
          qres.answer = { id: this.responseByQuestionId[q.id] }
        } else if (q.type === 'OPTIONS-MUL') {
          qres.answer = { ids: this.responseByQuestionId[q.id] }
        } else if (q.type === 'TEXT-SHORT') {
          qres.answer = { value: this.responseByQuestionId[q.id] }
        } else if (q.type === 'TEXT-PARA') {
          qres.answer = { value: this.responseByQuestionId[q.id] }
        } else if (q.type === 'DATE') {
          qres.answer = { value: moment(this.responseByQuestionId[q.id]).format('DD-MMM-YYYY') }
        } else if (q.type === 'TIME') {
          qres.answer = { value: moment(this.responseByQuestionId[q.id]).format('HH:mm:ss') }
        } else if (q.type === 'INT') {
          qres.answer = { value: this.responseByQuestionId[q.id] }
        } else if (q.type === 'FLOAT') {
          qres.answer = { value: this.responseByQuestionId[q.id] }
        } else if (q.type === this.responseByQuestionId[q.id]) {
          qres.answer = { value: this.responseByQuestionId[q.id] }
        }
      }
      if (q.otherAllowed === 'YES' && this.responseByQuestionId[AppHelper.getOtherValuePrefix() + q.id]) {
        qres.answer.otherValue = this.responseByQuestionId[AppHelper.getOtherValuePrefix() + q.id]
      }
      jsonBody[q.id] = qres
    }


    const payload = {
      qress: jsonBody
    }

    if(this.state.retake) {
      payload.retake  = true
    }

    //console.log('payload', payload)


    ApiHelper.call(
      {
        method: 'POST',
        endPoint: ApiHelper.makeUrlPath(['questionresps']),
        jsonBody: payload
      },
      function (err, result) {
        if (err) {
          this.setState({
            errMsg: Helper.getErrorMsg(err),
            inProcess: false
          })
          return
        }
        this.responseByQuestionId = {}
        const surveySection = this.state.surveySection
        surveySection.subsections[this.state.activeStep].complete = true
        if (this.state.activeStep < this.state.subSectionQuestions.length - 1) {
          this.setState({
            errMsg: null,
            activeStep: this.state.activeStep + 1,
            inProcess: false,
            surveySection: surveySection,
            retake: false
          });
        } else {
          this.props.history.push(Controller.get().getHomeByRole())
        }
        window.scrollTo(0, 0)
      }.bind(this))
  }

  onSkip = (hideVisitLaterPopup) => {
    if (this.state.visitLaterPopup || hideVisitLaterPopup) {
      this.navigateToNextSubSection()
    } else {
      this.setState({
        showMsgDialog: true
      })
    }
  }

  closeMsgDialog = (action) => {
    this.setState({
      showMsgDialog: false,
      retake: false
    }, () => {
      setTimeout(() => { //TODO: immediate calling of window scroll does not have any effect
        if (action === 'OK') {
          window.scrollTo(0, 0)
        }
      }, 100)
    })

    if (action === 'OK') {
      if (this.state.visitLaterPopup) {
        localStorage.setItem('visitLaterPopup', 'YES');
      } else {
        localStorage.setItem('visitLaterPopup', 'NO');
      }
    } else {
      this.setState({
        visitLaterPopup: localStorage.getItem('visitLaterPopup') === 'YES' ? true : false,
      })
    }

    if (action === 'OK') {
      this.navigateToNextSubSection()
    }
  }

  navigateToNextSubSection = () => {
    window.scrollTo(0, 0)
    if (this.state.activeStep < this.state.subSectionQuestions.length - 1) {
      this.setState({
        errMsg: null,
        activeStep: this.state.activeStep + 1,
      });
      this.responseByQuestionId = {}
    } else {
      this.props.history.push('/survey')
    }
  }

  isSubsectionCompleted = () => {
    if (this.state.surveySection.subsections && this.state.surveySection.subsections.length !== 0) {
      return this.state.surveySection.subsections[this.state.activeStep].complete
    } else {
      return false
    }
  }

  subSectionReTakeAllowed = () => {
    if (this.state.surveySection.subsections &&
      this.state.surveySection.subsections.length !== 0 &&
      this.state.surveySection.subsections[this.state.activeStep].complete) {
      return (this.state.surveySection.subsections[this.state.activeStep].allowRetakes === 'YES')
    } else {
      return false
    }
  }

  renderTagQuestions = (question) => {
    const tagQ = []
    let tagQuestions = this.state.tagByQuestionId[question.id]
    if (tagQuestions) {
      tagQuestions = tagQuestions.sort((a, b) => Number(a.order) - Number(b.order))
      for (const ques of tagQuestions) {
        if (ques.show) {

          if (!ques.tagQues) continue

          let tagQuesMultipleSelectMode = true

          if (ques.tagQues.type === 'OPTIONS-MUL') {
            Object.keys(ques.tagQues.options).map(option => {
              if (!ques.tagQues.options[option].acceptOptions) {
                tagQuesMultipleSelectMode = false
              }
            })
          }

          tagQ.push(
            <FormFieldComponent
              ques={ques.tagQues}
              multipleSelectMode={tagQuesMultipleSelectMode}
              handleState={this.handleState}
            />
          )
        }
      }
      return tagQ || ''
    }
    return ''
  }

  render() {
    if (this.state.fetchState === ApiHelper.State.LOADING) {
      return UiHelper.componentLoadingView();
    } else if (this.state.fetchState === ApiHelper.State.ERROR) {
      return UiHelper.errorView(this);
    } else {
      return this.readyView();
    }
  }

  readyView() {
    let noQues = false
    let introQues = false
    let subSectionReTake = this.subSectionReTakeAllowed()
    return (
      <div className={css(AppStyles.containerNarrow, Styles.containerNarrow)}>
        {this.state.surveySection &&
          <div className={css(CommonStyles.headerContainer)}>
            <p className={css(CommonStyles.headerContent)}>{this.state.surveySection.title}</p>
          </div>
        }
        {this.state.surveySection &&
          <SectionProgress
            data={this.state.surveySection}
            handleStep={this.handleStep}
            activeStep={this.state.activeStep}
          />
        }

        {(!this.state.surveySection ||
          !this.state.surveySection.subsections ||
          this.state.surveySection.subsections.length === 0) &&
          <div className={css(Styles.stepperContent, Styles.customPaddingTop)}>
            {UiHelper.emptyView('No sections found')}
          </div>
        }

        {this.state.surveySection &&
          this.state.surveySection.subsections &&
          this.state.surveySection.subsections.length !== 0 &&
          <div className={css(Styles.stepperContent)}>
            {this.state.subSectionQuestions &&
              this.state.subSectionQuestions.map((sub, index) => {
                if (index === this.state.activeStep &&
                  this.state.activeStep < this.state.surveySection.subsections.length &&
                  (!this.state.surveySection.subsections[this.state.activeStep].complete || this.state.retake)
                ) {
                  introQues = true
                  if (!sub || !sub.items || sub.items.length === 0) {
                    noQues = true
                    return (
                      <div className={css(Styles.customPaddingTop)}>
                        {UiHelper.emptyView('No questions found')}
                      </div>
                    )
                  }
                  return (
                    sub.items.sort(function (a, b) { return (Number(a.order) - Number(b.order)) })
                      .map(ques => {
                        if (ques.type !== 'LABEL' && ques.type !== 'LABEL-BOLD') {
                          introQues = false
                        }
                        let multipleSelectMode = true
                        {
                          ques.type === 'OPTIONS-MUL' &&
                            Object.keys(ques.options).map(option => {
                              if (!ques.options[option].acceptOptions) {
                                multipleSelectMode = false
                              }
                            })
                        }

                        if (ques.infoTitle && ques.infoDescr) {
                          ques.info = {
                            title: ques.infoTitle,
                            desc: ques.infoDescr
                          }
                        }

                        return (
                          <div key={ques.id}>
                            <div>
                              {!ques.tag &&
                                <FormFieldComponent
                                  ques={ques}
                                  multipleSelectMode={multipleSelectMode}
                                  handleState={this.handleState}
                                />}
                            </div>
                            <div>
                              {this.renderTagQuestions(ques)}
                            </div>
                          </div>
                        )
                      })
                  )
                }
              })}


            <div className={css(Styles.buttonContainer)}>
              <StepperButtonComponent
                errMsg={this.state.errMsg}
                noQues={noQues}
                introQues={introQues}
                subSectionCompleted={this.isSubsectionCompleted()}
                subSectionReTake={subSectionReTake}
                activeStep={this.state.activeStep}
                onDone={this.onDone}
                onSkip={this.onSkip}
                onReTake={this.onReTake}
                retake={this.state.retake}
                inProcess={this.state.inProcess}
              />
            </div>
          </div>
        }
        <SubmitConfirmation
          submitAnswerPopup={this.state.submitAnswerPopup}
          confirmationDialog={this.state.confirmationDialog}
          handleCheckbox={this.handleCheckbox}
          confirmationDialogClose={this.confirmationDialogClose}
          onSubmit={this.onSubmit}
        />
        <MsgDialog
          showDialog={this.state.showMsgDialog}
          visitLaterPopup={this.state.visitLaterPopup}
          closeDialog={this.closeMsgDialog}
          value={'visitLaterPopup'}
          handleCheckbox={this.handleVisitLater}
          leftBtnTitle={'CANCEL'}
          rightBtnTitle={'OK'}
          title={'Please Note!'}
          descr={'Moving on from this section without submitting will cause your answers to be erased.'}
        />
      </div>
    );
  }

  getQuesTag = (quesId) => {
    const ansId = this.responseByQuestionId[quesId]
    if (this.state.tagByQuestionId[quesId] && this.state.tagByQuestionId[quesId].length > 0) {
      const tagQuestionsByquesId = this.state.tagByQuestionId[quesId]
      const tagByQuestionId = this.state.tagByQuestionId
      for (const q of tagQuestionsByquesId) {
        if (q.ansId === ansId) {
          q.show = true
        } else {
          q.show = false
          if(q.tagQues && q.tagQues.type === 'TABULAR' && q.tagQues.subQuestions) {
            for(const subQuestion of q.tagQues.subQuestions) {
              delete this.responseByQuestionId[subQuestion.id]
            }
          } else {
            delete this.responseByQuestionId[q.tagQuesId]
          }
        }
      }
      tagByQuestionId[quesId] = tagQuestionsByquesId
      this.setState({
        tagByQuestionId: tagByQuestionId
      })
    }
    return null;
  }

}



const Styles = StyleSheet.create({
  containerNarrow: {
    height: 'unset',
    width: '80%',
    '@media (max-width: 1024px)': {
      minWidth: 'unset',
      flex: 'unset',
      width: '90%'
    }
  },
  stepperContent: {
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: AppTheme.secondaryBg,
    flex: 1,
    padding: 30,
    paddingTop: 0,
    marginBottom: 30,
    borderRadius: 30,
    '@media (max-width: 767px)': {
      padding: 10,
    }
  },

  buttonContainer: {
    flex: 1,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: 40,
    '@media (max-width: 767px)': {
      marginTop: 20,
    }
  },
  customPaddingTop: {
    paddingTop: 30,
  }
})



// WEBPACK FOOTER //
// ./src/screens/SurveySection.js